/*
 * Listener for view all recommended courses - shown on default page template
 * 
 */

 (function($){
 	var display_rec_selection = function(caller){
 		if(showAll){
 			$('.recommended_container').show();
 			if(caller){
 				caller.text('View Selection');	
 			}
 			
 		}
 		else{
 			$('.recommended_container:nth-of-type(n+4)').hide();
 			if(caller){
 				caller.text('View All');	
 			}
 			
 		}
 	}

 	var showAll = false;
 	var numCourses = $('.recommendations .recommended_container').length;

 	if(numCourses > 3 && $('.home').length === 0){ //disable this for homepage
 		display_rec_selection();
 		$('.recommendations #button_view_all').on('click', function(event) {
	 		event.preventDefault();
	 		/* Act on the event */
	 		showAll = !showAll;
	 		display_rec_selection($(this));
	 	});
 	}
 	else{
		$('.recommendations #button_view_all').hide();
		if(numCourses === 0){
			$('.recommendations .heading').hide();
		}	
 	}

 })(jQuery);